import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
/**
 * A component that ensures i18n translations are loaded before rendering its children.
 * Displays a loader while translations are being fetched.
 * @returns The children components once translations are ready, otherwise the loader.
 */
var I18NModuleHandler = function (_a) {
    var children = _a.children, loader = _a.loader, namespace = _a.namespace;
    var ready = useLanguage(namespace).ready;
    if (!ready) {
        return React.createElement(React.Fragment, null, loader);
    }
    return React.createElement(React.Fragment, null, children);
};
export default I18NModuleHandler;
